<template>
  <div class="head-menu">
    <div class="px-10 px-sm-4">
      <logo/>
      <div class="menu menu-center d-none d-md-flex">
        <ul>
          <!-- <li>
                      <a href="#">Home</a>
                    </li>
                    <li>
                      <a href="#">Home</a>
                    </li> -->
        </ul>
      </div>
      <div class="d-none d-md-flex menu menu-right">
        
      </div>
    </div>
  </div>
  <div class="layout-content">
    <slot />
  </div>
  <!-- <div class="layout-footer mt-5 pb-4">
              @copyright - Cauhoi.vn - 2023
            </div> -->
<confirmation />
<toast />
</template>

<style lang="scss" scoped>
.layout-content {
  // min-height: 100vh;
  background-color: var(--color-body-bg);
}

.head-menu {
  background-color: var(--color-top-menu-bg);
  // border-bottom: 1px solid var(--color-top-menu-border);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;

  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right,
        var(--color-body-bg),
        var(--color-top-menu-border),
        var(--color-body-bg));
  }

  >div {
    display: flex;

    >div {
      flex: 1;
      height: 60px;
    }

    .menu {
      .btn {
        margin-bottom: 0 !important;
        padding: 0.5rem 1rem;
        color: var(--color-top-menu-text);
      }

      >ul {
        display: flex;
        list-style: none;
        padding: 0;
        align-items: center;
        height: 100%;
        width: fit-content;

        >li {
          margin-left: 15px;
          margin-right: 15px;
          font-weight: 600;
          display: flex;
          align-items: center;

          a {
            color: var(--color-top-menu-text);

            &:hover {
              color: var(--color-top-menu-text-hover);
            }
          }
        }
      }

      &.menu-center {
        >ul {
          margin: auto;
        }
      }

      &.menu-right {
        >ul {
          margin: 0 0 0 auto;

          >li {
            .avatar {
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
}

.layout-footer {
  text-align: center;
}
</style>

<script>
import Confirmation from "../components/Confirmation/Confirmation.vue";
import Toast from "../components/Toast/Toast.vue";

export default {
  components: {
    Confirmation,
    Toast
  },

  methods: {
    applyTheme(){
      this.$store.dispatch('theme', null);
    }
  },

  mounted() {
    this.applyTheme();
  },
};
</script>
